import { isDevelopment } from '@const/consts';

export const getSharedLink = (sharedOguid: string): string => {
  const hostname = window.location.hostname;
  const sharedBranch = hostname.match(
    /^f-gdf-(main|dev|main-vn|dev-vn)\.dev\.info-logistics\.eu$/
  )?.[1] ?? 'dev';

  return isDevelopment
    ? `https://f-shared-gd-${sharedBranch}.dev.info-logistics.eu/${sharedOguid}`
    : `https://shared.${hostname}/${sharedOguid}`;
};
